/**
 * `node:module` — `createRequire` for src/cli/index.ts, which loads each command lazily with
 * `require("./triage.js")` and the like. The demo registers the bundled modules here by file name.
 */
const registry = new Map<string, unknown>()
export function registerModules(mods: Record<string, unknown>): void {
  for (const [k, v] of Object.entries(mods)) registry.set(k, v)
}
export function createRequire(): (id: string) => unknown {
  return (id: string) => {
    const key = id.split("/").pop() ?? id
    if (!registry.has(key)) throw new Error(`require(${id}) is not available in the browser demo`)
    return registry.get(key)
  }
}
export default { createRequire }
